import { FlexLayout } from '@deity/falcon-ui';
import {
  countMappedRequiredFields,
  countSchemaFields,
  mappingSummary
} from 'components/Footer/MappingSummaryFooter/helpers';
import { ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import type { GetMappingQuery, GetModelQuery } from 'services/graphql/generated/operations';
import { getParams } from 'utils';
import { MappingEdgeVisualizer } from './MappingEdgeVisualizer';
import { MappingStats } from './MappingStats';
import { ModelInfo } from './ModelInfo';

interface MappingSummaryProps {
  mappingData?: GetMappingQuery;
  sourceModelData?: GetModelQuery;
  targetModelData?: GetModelQuery;
}
export const MappingSummary: FC<MappingSummaryProps> = ({ mappingData, sourceModelData, targetModelData }) => {
  const { pathname } = useLocation();
  const params: any = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const sourceSchemaCount = countSchemaFields(sourceModelData?.getModel.schema).fields;

  const targetSchemaCount = countSchemaFields(targetModelData?.getModel.schema).fields;

  const mappingCount = countSchemaFields(mappingData?.getMapping.schema).fields;
  const processorCount = countSchemaFields(mappingData?.getMapping.schema).processors;

  const requiredTargetFieldsCount = countSchemaFields(targetModelData?.getModel.schema).requiredFields;

  const requiredSourceFieldsCount = countSchemaFields(targetModelData?.getModel.schema).requiredFields;

  const mappedRequiredField = countMappedRequiredFields(
    mappingData?.getMapping.schema,
    targetModelData?.getModel.schema
  );

  const summary = mappingSummary(mappingData?.getMapping.schema);

  return (
    <FlexLayout justifyContent="space-between" alignItems="center" flexWrap="nowrap" css={{ position: 'relative' }}>
      <ModelInfo
        name={sourceModelData?.getModel.name || '-'}
        fieldCount={sourceSchemaCount || 0}
        requiredFields={requiredTargetFieldsCount || 0}
        validation={sourceModelData?.getModel.validation}
        packageUuid={params.packageId}
        packageVersionUuid={sourceModelData?.getModel.packageVersionUuid}
        uuid={sourceModelData?.getModel.uuid}
      />
      <MappingEdgeVisualizer mappingEdges={summary?.mappingEdges || []} />
      <ModelInfo
        name={targetModelData?.getModel.name || '-'}
        fieldCount={targetSchemaCount || 0}
        requiredFields={requiredSourceFieldsCount || 0}
        validation={sourceModelData?.getModel.validation}
        packageUuid={params.packageId}
        packageVersionUuid={targetModelData?.getModel.packageVersionUuid}
        uuid={targetModelData?.getModel.uuid}
      />
      <MappingStats
        mappingCount={mappingCount || 0}
        processorCount={processorCount || 0}
        fieldsWithProcessor={summary?.fieldsWithProcessor || 0}
        requiredTargetField={requiredTargetFieldsCount || 0}
        mappedRequiredField={mappedRequiredField || 0}
      />
    </FlexLayout>
  );
};
